<svg-icon [class]="cssClasses"
          [ngClass]="[showSpinner ? SPIN_ANIMATION_CLASS_NAME : '']"
          [src]="showSpinner ? spinnerPath : iconPath"
          [svgStyle]="iconStyle"/>